import { startCase } from 'lodash';

export interface DealFilter {
  label: string;
  key: string;
  operatorLabel?: string;
  ChipLabel?: React.ComponentType<{
    label?: React.ReactNode;
    value?: any;
    column?: any;
    operatorLabel?: any;
  }>;
  // RenderChip?: JSX.Element;
}
export const $contains: DealFilter = {
  label: 'Search',
  key: '$contains',
  ChipLabel: ({ value, label }) => (
    <>
      {label}: {value}
    </>
  ),
};

export const $eq: DealFilter = {
  label: 'Exact',
  key: '$eq',
  operatorLabel: 'is exactly',
};

export const $sw: DealFilter = {
  label: 'Starts With',
  key: '$sw',
  operatorLabel: 'starts with',
};

export const $ew: DealFilter = {
  label: 'Ends With',
  key: '$ew',
  operatorLabel: 'ends with',
};

export const $gt: DealFilter = {
  label: 'More Than',
  key: '$gt',
  operatorLabel: '>',
};

export const $gte: DealFilter = {
  label: 'More Than or exact',
  key: '$gte',
  operatorLabel: '≥',
};

export const $lt: DealFilter = {
  label: 'Less Than',
  key: '$lt',
  operatorLabel: '<',
};

export const $lte: DealFilter = {
  label: 'Less Than or exact',
  key: '$lte',
  operatorLabel: '≤',
};

export const $bw: DealFilter = {
  label: 'Between',
  key: '$bw',
  ChipLabel: ({ label, value }) => (
    <>
      {value[0]} ≤ {label} ≤ {value[1]}
    </>
  ),
};
export const $in: DealFilter = {
  label: 'In',
  key: '$in',
  operatorLabel: 'one of',
  ChipLabel: ({ label, value }) => (
    <>{`${label} one of ${value.split(',').map(startCase).join(', ')}`}</>
  ),
};
export const $inany: DealFilter = {
  label: 'In',
  key: '$inany',
  operatorLabel: 'one of',
  ChipLabel: ({ label, value }) => <>{`${label}: ${value.split(',').map(startCase).join(', ')}`}</>,
};
export const $empty: DealFilter = {
  label: 'empty',
  key: '$empty',
  ChipLabel: ({ label, value }) => (
    <>
      {label} {value === 'false' ? 'is not empty' : 'is empty'}
    </>
  ),
};
// for similar deal
export const $similar: DealFilter = {
  label: 'Search',
  key: '$similar',
  ChipLabel: ({ value, label }) => <>Similar deals.</>,
};
export const $linked: DealFilter = {
  label: 'linked',
  key: '$linked',
  ChipLabel: ({ label, value }) => (
    <>
      {label}
      {value === 'yes' ? ' is linked' : ' is not linked'}
    </>
  ),
};

export const operatorByKey: Record<string, DealFilter> = {
  $contains,
  $eq,
  $sw,
  $ew,
  $gte,
  $lte,
  $lt,
  $gt,
  $bw,
  $in,
  $empty,
  $similar,
  $linked,
  $inany,
};
